import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminLinkPartnersLinkPartnerRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ link_pattern_id }) {
    const { content } = await this.store.request(
      findRecord('link-pattern', link_pattern_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
